import { render, staticRenderFns } from "./research-filter-bar.vue?vue&type=template&id=5b71272a&scoped=true"
import script from "./research-filter-bar.vue?vue&type=script&lang=js"
export * from "./research-filter-bar.vue?vue&type=script&lang=js"
import style0 from "./research-filter-bar.vue?vue&type=style&index=0&id=5b71272a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71272a",
  null
  
)

export default component.exports